export default "__VITE_PUBLIC_ASSET__efcc0119__"